import { ReactElement } from "react";
import { IButton } from "../Button/Button.types";

export enum EInfoBlockKind {
  ERROR = "error",
  INFO = "info",
  WARNING = "warning",
  "SUCCESS" = "success",
}

export interface IInfoBlock {
  icon?: ReactElement | null;
  message: String | ReactElement | any[];
  buttons?: Array<IButton>;
  title?: String;
  displayMobileIcon?: boolean;
  mobileButtonsPosition?: "right" | "bottom";
  desktopButtonsPosition?: "right" | "bottom";
  iconPosition?: "top" | "center";
  kind?: EInfoBlockKind;
  iconInTitle?: boolean;
  important?: boolean;
}
